const financialAccountQueryKey = 'financial-account'

export const financialAccountKeys = {
  getFinancialAccount: [financialAccountQueryKey] as const,
  getBalanceSummary: [financialAccountQueryKey, 'balance-summary'] as const,
  getAccountDetails: [financialAccountQueryKey, 'account-details'] as const,
  getScaAuthCode: [financialAccountQueryKey, 'sca-auth-code'] as const,
  getScaToken: [financialAccountQueryKey, 'sca-token'] as const,
  getAirwallexAuthCode: [
    financialAccountQueryKey,
    'airwallex-auth-code',
  ] as const,
}
